// extracted by mini-css-extract-plugin
export default {"spanBlock":"SuperEditableSpan_spanBlock__A7wwE","span":"SuperEditableSpan_span__Kjur9","input":"SuperEditableSpan_input__fifa6","pen":"SuperEditableSpan_pen__EqjJ1"};